import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { fetchStationDetail } from './fetchStationDetail'

function useStationById(interfaceId: any, stationId: any, options?: any) {
  return useQuery(
    [queryKeys.stations, stationId],
    async () => {
      if (!interfaceId || !stationId) return null
      return fetchStationDetail(interfaceId.toString(), stationId.toString())
    },
    {
      ...(options && options),
    },
  )
}

export default useStationById
